'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ToolbarsContainer from 'InpageEditorUI/containers/ToolbarsContainer';
import HoverOverlayContainer from 'InpageEditorUI/containers/HoverOverlayContainer';
import { getAllLayoutSectionTreesAsMap, getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { layoutSectionHoverPositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getBodyOffset } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import TemporaryOverlaysContainer from './TemporaryOverlaysContainer';
import { getIsUngatedForCommentPopOver } from 'ContentEditorUI/redux/selectors/authSelectors';
import { GridsLayoutGenerationOverlayContainer } from './GridsLayoutGenerationOverlayContainer';
import { getIsGridLayoutGenerationAvailable } from 'ContentEditorUI/redux/selectors/gridsLayoutGenerationSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    hasAnyLayoutSections: getHasAnyLayoutSections(state),
    layoutSectionTrees: getAllLayoutSectionTreesAsMap(state),
    bodyOffset: getBodyOffset(state),
    isUngatedForCommentPopOver: getIsUngatedForCommentPopOver(state),
    isGridLayoutGenerationAvailable: getIsGridLayoutGenerationAvailable(state)
  };
};
class UnifiedOverlaysAndToolbarsContainer extends Component {
  bodyOffsetStyle() {
    const {
      bodyOffset
    } = this.props;
    return {
      position: 'absolute',
      top: -bodyOffset.top,
      left: -bodyOffset.left,
      zIndex: 2147483598 /* Copy of $zIndex1 from `_globals.sass` */
    };
  }
  render() {
    const {
      bus,
      children,
      isUngatedForCommentPopOver,
      isGridLayoutGenerationAvailable
    } = this.props;
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsxs("div", {
        className: `${NAMESPACE_CLASS}`,
        style: this.bodyOffsetStyle(),
        children: [/*#__PURE__*/_jsx(ToolbarsContainer, {
          bus: bus,
          isCommentable: isUngatedForCommentPopOver
        }), /*#__PURE__*/_jsx(HoverOverlayContainer, {}), /*#__PURE__*/_jsx(TemporaryOverlaysContainer, {}), isGridLayoutGenerationAvailable && /*#__PURE__*/_jsx(GridsLayoutGenerationOverlayContainer, {}), children]
      })
    );
  }
}
UnifiedOverlaysAndToolbarsContainer.propTypes = {
  bus: PropTypes.object.isRequired,
  bodyOffset: PropTypes.object.isRequired,
  children: PropTypes.node,
  isUngatedForCommentPopOver: PropTypes.bool,
  isGridLayoutGenerationAvailable: PropTypes.bool
};
export default connect(mapStateToProps, {
  layoutSectionHoverPositionsCleared
})(UnifiedOverlaysAndToolbarsContainer);